import {
  CreateCustomerType,
  CustomerAccountDataType,
  CustomerDropDown,
  CustomerAccountRequestParams,
  IAlePaySuccesResponnse,
  ImportParamsTypes,
  IntegrationDropDown,
  PreviewImportDataType
} from './types';

import axiosInstance from 'services/common/instance';
import { IAlePayRequest, ICheckoutRequest } from 'services/servicePackages/type';

export const getCustomerAccountsService = async (
  params: CustomerAccountRequestParams
): Promise<APIPagination<CustomerAccountDataType[]>> => {
  const res = await axiosInstance.get('customer-accounts', { params });
  return res.data;
};

export const getCustomerAccountByIdService = async (code: string)
  : Promise<CustomerAccountDataType> => {
  const res = await axiosInstance.get(`customer-accounts/${code}`);
  return res.data.data;
};

export const createUserService = async (data: CreateCustomerType)
  : Promise<CustomerAccountDataType> => {
  const res = await axiosInstance.post('customer-accounts', data);
  return res.data;
};

export const previewImportCustomerService = async (
  params: ImportParamsTypes,
): Promise<PreviewImportDataType> => {
  const bodyForm = new FormData();
  bodyForm.append('file', params.file);

  const res = await axiosInstance.post('customer-accounts/import-preview', bodyForm);
  return res.data.data;
};

export const downloadCustomerAccountService = async (): Promise<{ data: { link: string } }> => {
  const res = await axiosInstance.post('customer-accounts/download-import');
  return res.data;
};

export const importCustomersService = async (
  data: ImportParamsTypes
): Promise<void> => {
  const bodyForm = new FormData();
  bodyForm.append('file', data.file);

  await axiosInstance.post('customer-accounts/import', bodyForm);
};

export const deleteCustomerAccountService = async (code: string): Promise<void> => {
  await axiosInstance.delete(`customer-accounts/${code}`);
};

export const deleteMultiCustomerAccountService = async (codes: string[]): Promise<void> => {
  await axiosInstance.delete('customer-accounts/destroy/multi', { data: { codes } });
};

export const updateCustomerAccountService = async (code: string, data: CreateCustomerType)
  : Promise<void> => {
  const res = await axiosInstance.put(`customer-accounts/${code}`, data);
  return res.data;
};

export const checkExistEmailService = async (
  data: { email: string, taxCode?: string }
): Promise<any> => {
  const res = await axiosInstance.post('checkout/check-email', data);
  return res.data.data;
};

export const checkoutService = async (data: ICheckoutRequest): Promise<any> => {
  const res = await axiosInstance.post('checkout', data);
  return res.data.data;
};

export const checkoutRetryService = async (token: string): Promise<ICheckoutRequest> => {
  const res = await axiosInstance.get(`checkout/retry/${token}`);
  return res.data.data;
};

export const checkPaymentStatus = async (data: IAlePayRequest): Promise<IAlePaySuccesResponnse> => {
  const res = await axiosInstance.post('checkout/payments/ale-pay/success', data);
  return res.data.data;
};

export const checkPaymentStatusCancel = async (data: IAlePayRequest): Promise<any> => {
  const res = await axiosInstance.post('checkout/payments/ale-pay/cancel', data);
  return res.data.data;
};

export const getCustomerDropDownService = async ({ agentCode }:
  { agentCode?: string | null }): Promise<{
    data: CustomerDropDown[];
  }> => {
  const response = await axiosInstance.get(`customer-accounts/agent/${agentCode}/dropdown/list`);
  return response.data;
};

export const getListZaloOAService = async ({ agentCode, channel }: {
  agentCode?: string;
  channel: string;
})
  : Promise<APIResponse<IntegrationDropDown[]>> => {
  const res = await axiosInstance.get(`agents/${agentCode}/integrations/dropdown/list?channel=${channel}`);
  return res.data;
};
